import React from 'react';
import useGlobalStyles from '../../../useGlobalStyles';
import useActivityItemStyles from './useActivityItemStyles';
import { Question, Answer, Comment } from '../../../../types';
import { getMetaData } from '../../../../tool';
import useActivityItem from '../../../../hooks/useActivityItem';

/**
 * Props for the Activity component.
 */
interface ActivityProps {
  activity: Question | Answer | Comment;
  type: 'question' | 'answer' | 'comment';
}

/**
 * ActivityItem component that renders the user's activity.
 * @param activity - the user's activity.
 * @param type - the type of activity.
 */
const ActivityItem: React.FC<ActivityProps> = ({ activity, type }) => {
  const { classes } = useActivityItemStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const { handleQuestionActivityClick, handleAnswerActivityClick, handleCommentActivityClick } =
    useActivityItem();

  if (type === 'question') {
    const q = activity as Question;
    return (
      <div className={classes.container} onClick={() => handleQuestionActivityClick(q._id)}>
        <div className={`${globalClasses.p} ${classes.text}`}>{q.title}</div>
        <div className={`${globalClasses.p} ${classes.date}`}>
          {getMetaData(new Date(q.askDateTime))}
        </div>
      </div>
    );
  }

  if (type === 'answer') {
    const a = activity as Answer;
    return (
      <div className={classes.container} onClick={() => handleAnswerActivityClick(a._id)}>
        <div className={`${globalClasses.p} ${classes.text}`}>{a.text}</div>
        <div className={`${globalClasses.p} ${classes.date}`}>
          {getMetaData(new Date(a.ansDateTime))}
        </div>
      </div>
    );
  }

  if (type === 'comment') {
    const c = activity as Comment;
    return (
      <div className={classes.container} onClick={() => handleCommentActivityClick(c._id)}>
        <div className={`${globalClasses.p} ${classes.text}`}>{c.text}</div>
        <div className={`${globalClasses.p} ${classes.date}`}>
          {getMetaData(new Date(c.commentDateTime))}
        </div>
      </div>
    );
  }

  return null;
};

export default ActivityItem;
